// import { createEnv } from "@t3-oss/env-nextjs"
// import { z } from "zod";

// const IS_MISSING_INITIALLY = true

// const env = createEnv({
//     server: {
//         ANALYZE: z.coerce.boolean().default(true),
//         NEXT_RUNTIME: z.enum(['nodejs', 'edge']),
//         NODE_ENV: z.enum(['development', 'production', 'test', 'staging']),
//         OPENAI_API_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(20).startsWith('sk-proj'),
//         EMAIL_SENDER: z.string().email(),
//         EMAIL_PORT: z.coerce.number().min(1).max(65535).default(587).describe('465 when using SSL, 587 when using TLS'),
//         EMAIL_HOST: z.string().min(4).describe('The email host to use for the email provider.').default('smtp.ionos.de'),
//         EMAIL_TLS: z.coerce.boolean().default(true),
//         EMAIL_USER: z.string().min(4).describe('The email user to use for the email provider, sometimes not an email address.'),
//         EMAIL_PASSWORD: z.string().min(2),
//         CONTACT_EMAIL: z.string().email(),
//         MAILER_PROVIDER: z.enum(['nodemailer', 'resend']).default('nodemailer'),
//         LANGCHAIN_CALLBACKS_BACKGROUND: z.string().url().optional().describe('The URL to use for the Langchain callbacks background.'),
//         LANGCHAIN_TRACING_V2: z.coerce.boolean().optional().default(true),
//         LANGSMITH_TRACING: z.coerce.boolean().optional().default(true),
//         LANGSMITH_ENDPOINT: z.string().url().optional().describe('The URL to use for the Langsmith endpoint.'),
//         LANGSMITH_API_KEY: z.string().optional().describe('The API key to use for the Langsmith endpoint.'),
//         LANGSMITH_PROJECT: z.string().optional().describe('The project to use for the Langsmith endpoint.'),
//         ENABLE_REACT_COMPILER: z.coerce.boolean().default(true),
//         TRIGGER_ACCESS_TOKEN: z.string().min(10).optional(),
//         RUNTIME_ENV: z.string().optional(),//vercel,local,
//         QDRANT_URL: IS_MISSING_INITIALLY ? z.string().optional() : z.string().url(),
//         QDRANT_API_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         QDRANT_PORT: z.coerce.number().min(1).max(65535).default(6333),
//         VOYAGE_API_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         OPENROUTER_API_KEY: z.string().min(10).optional(),
//         REQUESTY_API_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         REDIS_URL: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         TAVILY_API_KEY: z.string().min(20).startsWith('tvly-').optional(),
//         PRIVATEMODE_API_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         VAPID_PRIVATE_KEY: IS_MISSING_INITIALLY ? z.string().optional() : z.string(),
//         VAPID_EMAIL: z.string().default('mailto:admin@widewideweb.com'),

//         CMS_CLIENT: z.enum(['wordpress', 'keystatic']).optional(),
//         LLM_ROUTER: z.enum(['requesty', 'openrouter']).default('requesty'),
//         NEXT_TELEMETRY_DISABLED: z.string().default('true'),
//         SUPABASE_SERVICE_ROLE_KEY: z.string().min(10),
//         SUPABASE_SECRET_KEY: z.string().min(10).optional(),
//         SUPABASE_DATABASE_PASSWORD: IS_MISSING_INITIALLY ? z.string().optional() : z.string().min(10),
//         SUPABASE_DATABASE_URL: z.string(),
//         SUPABASE_DB_WEBHOOK_SECRET: z.string().min(10),

//         // Security
//         CAPTCHA_SECRET_TOKEN: z.string().min(1).optional(),

//         // Billing
//         STRIPE_SECRET_KEY: z.string().min(1).optional(),
//         STRIPE_WEBHOOK_SECRET: z.string().min(1).optional(),
//         LEMON_SQUEEZY_SECRET_KEY: z.string().min(1).optional(),
//         LEMON_SQUEEZY_STORE_ID: z.string().min(1).optional(),
//         LEMON_SQUEEZY_SIGNING_SECRET: z.string().min(1).optional(),
//         STRIPE_ENABLE_TRIAL_WITHOUT_CC: z.coerce.boolean().optional(),

//         // Email
//         RESEND_API_KEY: z.string().min(1).optional(),

//         // CMS
//         KEYSTATIC_GITHUB_TOKEN: z.string().min(1).optional(),
//         KEYSTATIC_PATH_PREFIX: z.string().optional(),
//         WORDPRESS_API_URL: z.string().url().optional(),

//         // Security
//         ENABLE_STRICT_CSP: z.coerce.boolean().optional().default(
//             false
//             // process.env.NODE_ENV === 'production'
//         ),
//         TURBO_TELEMETRY_DISABLED: z.string().default('1'),
//         DO_NOT_TRACK: z.string().default('1'),

//         SERPER_API_KEY: z.string().min(1).optional(),
//     },

//     // public environment variables
//     client: {
//         NEXT_PUBLIC_ENABLE_CODE: z.coerce.boolean().default(false),
//         NEXT_PUBLIC_AUTH_MAGIC_LINK: z.coerce.boolean().default(false),
//         NEXT_PUBLIC_TRIGGER_ACCESS_TOKEN_PUBLIC: z.string().optional(),
//         NEXT_PUBLIC_PRIVATEMODE_API_KEY: z.string(),
//         NEXT_PUBLIC_PRIVATEMODE_URL: z.string().url(),
//         NEXT_PUBLIC_VAPID_PUBLIC_KEY: z.string().min(5),
//         NEXT_PUBLIC_MONITORING_PROVIDER: z.enum(['sentry', 'baselime', 'none']).default('sentry'),
//         NEXT_PUBLIC_SENTRY_DSN: z.string(),
//         NEXT_PUBLIC_SENTRY_ENVIRONMENT: z.string().optional(),
//         NEXT_PUBLIC_BASELIME_KEY: z.string().optional(),
//         NEXT_PUBLIC_SUPABASE_URL: z.string(),
//         NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string(),
//         NEXT_PUBLIC_SUPABASE_PUBLIC_KEY: z.string().optional(),
//         NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string(),
//         NEXT_PUBLIC_SITE_URL: z.string().url().default('https://helferchat.widewideweb.com'),
//         NEXT_PUBLIC_PRODUCT_NAME: z.string().default('Helferchat'),
//         NEXT_PUBLIC_SITE_TITLE: z.string().default('HelferChat - Sichere KI-Lösung aus einer Hand'),
//         NEXT_PUBLIC_SITE_DESCRIPTION: z.string().default('Sichere KI-Lösung aus einer Hand'),
//         NEXT_PUBLIC_DEFAULT_THEME_MODE: z.enum(['light', 'dark', 'system']).default('system'),
//         NEXT_PUBLIC_THEME_COLOR: z.string().default('#ffffff'),
//         NEXT_PUBLIC_THEME_COLOR_DARK: z.string().default('#0a0a0a'),
//         NEXT_PUBLIC_AUTH_PASSWORD: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_CAPTCHA_SITE_KEY: z.string(),
//         NEXT_PUBLIC_BILLING_PROVIDER: z.enum(['stripe', 'lemon-squeezy']).default('stripe'),
//         NEXT_PUBLIC_KEYSTATIC_CONTENT_PATH: z.string().optional(),
//         NEXT_PUBLIC_KEYSTATIC_STORAGE_KIND: z.enum(['local', 'cloud', 'github']).optional(),
//         NEXT_PUBLIC_KEYSTATIC_STORAGE_REPO: z.string().min(1).optional(),
//         NEXT_PUBLIC_LOCALES_PATH: z.string().optional().default('apps/web/public/locales'),
//         NEXT_PUBLIC_DEFAULT_LOCALE: z.string().default('de'),
//         NEXT_PUBLIC_ENABLE_THEME_TOGGLE: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_DELETION: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_BILLING: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_DELETION: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_BILLING: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_CREATION: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_LANGUAGE_PRIORITY: z.enum(['application', 'user']).default('application'),

//         // Navigation
//         NEXT_PUBLIC_USER_NAVIGATION_STYLE: z.enum(['sidebar', 'header', 'custom']).optional(),
//         NEXT_PUBLIC_HOME_SIDEBAR_COLLAPSED: z.coerce.boolean().optional(),
//         NEXT_PUBLIC_TEAM_NAVIGATION_STYLE: z.enum(['sidebar', 'header', 'custom']).optional(),
//         NEXT_PUBLIC_TEAM_SIDEBAR_COLLAPSED: z.coerce.boolean().optional(),
//         NEXT_PUBLIC_SIDEBAR_COLLAPSIBLE_STYLE: z.enum(['offcanvas', 'icon', 'none']).optional(),
//         NEXT_PUBLIC_ENABLE_SIDEBAR_TRIGGER: z.coerce.boolean().optional(),

//         // Notifications
//         NEXT_PUBLIC_ENABLE_NOTIFICATIONS: z.coerce.boolean().optional(),
//         NEXT_PUBLIC_REALTIME_NOTIFICATIONS: z.coerce.boolean().optional(),

//         // Features
//         NEXT_PUBLIC_ENABLE_VERSION_UPDATER: z.coerce.boolean().optional(),
//         NEXT_PUBLIC_VERSION_UPDATER_REFETCH_INTERVAL_SECONDS: z.coerce.number().min(1).max(86400).optional(),
//         NEXT_PUBLIC_DISPLAY_TERMS_AND_CONDITIONS_CHECKBOX: z.coerce.boolean().optional(),
//         NEXT_PUBLIC_AUTH_IDENTITY_LINKING: z.coerce.boolean().default(true),
//         NEXT_PUBLIC_AUTH_OTP: z.coerce.boolean().default(true),
//     },

//     runtimeEnv: {
//         ANALYZE: process.env.ANALYZE,
//         NODE_ENV: process.env.NODE_ENV,
//         OPENAI_API_KEY: process.env.OPENAI_API_KEY,
//         EMAIL_SENDER: process.env.EMAIL_SENDER,
//         EMAIL_PORT: process.env.EMAIL_PORT,
//         EMAIL_HOST: process.env.EMAIL_HOST,
//         EMAIL_TLS: process.env.EMAIL_TLS,
//         EMAIL_USER: process.env.EMAIL_USER,
//         EMAIL_PASSWORD: process.env.EMAIL_PASSWORD,
//         CONTACT_EMAIL: process.env.CONTACT_EMAIL,
//         MAILER_PROVIDER: process.env.MAILER_PROVIDER,
//         LANGCHAIN_CALLBACKS_BACKGROUND: process.env.LANGCHAIN_CALLBACKS_BACKGROUND,
//         LANGCHAIN_TRACING_V2: process.env.LANGCHAIN_TRACING_V2,
//         LANGSMITH_TRACING: process.env.LANGSMITH_TRACING,
//         LANGSMITH_ENDPOINT: process.env.LANGSMITH_ENDPOINT,
//         LANGSMITH_API_KEY: process.env.LANGSMITH_API_KEY,
//         LANGSMITH_PROJECT: process.env.LANGSMITH_PROJECT,
//         TAVILY_API_KEY: process.env.TAVILY_API_KEY,
//         ENABLE_REACT_COMPILER: process.env.ENABLE_REACT_COMPILER,
//         TRIGGER_ACCESS_TOKEN: process.env.TRIGGER_ACCESS_TOKEN,
//         RUNTIME_ENV: process.env.RUNTIME_ENV,
//         QDRANT_URL: process.env.QDRANT_URL,
//         QDRANT_API_KEY: process.env.QDRANT_API_KEY,
//         QDRANT_PORT: process.env.QDRANT_PORT,
//         VOYAGE_API_KEY: process.env.VOYAGE_API_KEY,
//         OPENROUTER_API_KEY: process.env.OPENROUTER_API_KEY,
//         REDIS_URL: process.env.REDIS_URL,
//         REQUESTY_API_KEY: process.env.REQUESTY_API_KEY,
//         PRIVATEMODE_API_KEY: process.env.PRIVATEMODE_API_KEY,
//         VAPID_PRIVATE_KEY: process.env.VAPID_PRIVATE_KEY,
//         VAPID_EMAIL: process.env.VAPID_EMAIL,
//         CMS_CLIENT: process.env.CMS_CLIENT,
//         LLM_ROUTER: process.env.LLM_ROUTER,
//         NEXT_TELEMETRY_DISABLED: process.env.NEXT_TELEMETRY_DISABLED,
//         SUPABASE_SERVICE_ROLE_KEY: process.env.SUPABASE_SERVICE_ROLE_KEY,
//         SUPABASE_SECRET_KEY: process.env.SUPABASE_SECRET_KEY,
//         SUPABASE_DATABASE_PASSWORD: process.env.SUPABASE_DATABASE_PASSWORD,
//         SUPABASE_DATABASE_URL: process.env.SUPABASE_DATABASE_URL,
//         SUPABASE_DB_WEBHOOK_SECRET: process.env.SUPABASE_DB_WEBHOOK_SECRET,

//         // Security
//         CAPTCHA_SECRET_TOKEN: process.env.CAPTCHA_SECRET_TOKEN,

//         // Billing
//         STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
//         STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
//         LEMON_SQUEEZY_SECRET_KEY: process.env.LEMON_SQUEEZY_SECRET_KEY,
//         LEMON_SQUEEZY_STORE_ID: process.env.LEMON_SQUEEZY_STORE_ID,
//         LEMON_SQUEEZY_SIGNING_SECRET: process.env.LEMON_SQUEEZY_SIGNING_SECRET,
//         STRIPE_ENABLE_TRIAL_WITHOUT_CC: process.env.STRIPE_ENABLE_TRIAL_WITHOUT_CC,

//         // Email
//         RESEND_API_KEY: process.env.RESEND_API_KEY,

//         // CMS
//         KEYSTATIC_GITHUB_TOKEN: process.env.KEYSTATIC_GITHUB_TOKEN,
//         KEYSTATIC_PATH_PREFIX: process.env.KEYSTATIC_PATH_PREFIX,
//         WORDPRESS_API_URL: process.env.WORDPRESS_API_URL,

//         // Security
//         ENABLE_STRICT_CSP: process.env.ENABLE_STRICT_CSP,

//         SERPER_API_KEY: process.env.SERPER_API_KEY,

//         NEXT_RUNTIME: process.env.NEXT_RUNTIME,

//         NEXT_PUBLIC_ENABLE_CODE: process.env.NEXT_PUBLIC_ENABLE_CODE,
//         NEXT_PUBLIC_AUTH_MAGIC_LINK: process.env.NEXT_PUBLIC_AUTH_MAGIC_LINK,
//         NEXT_PUBLIC_TRIGGER_ACCESS_TOKEN_PUBLIC: process.env.NEXT_PUBLIC_TRIGGER_ACCESS_TOKEN_PUBLIC,
//         NEXT_PUBLIC_PRIVATEMODE_API_KEY: process.env.NEXT_PUBLIC_PRIVATEMODE_API_KEY,
//         NEXT_PUBLIC_PRIVATEMODE_URL: process.env.NEXT_PUBLIC_PRIVATEMODE_URL,
//         NEXT_PUBLIC_VAPID_PUBLIC_KEY: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
//         NEXT_PUBLIC_MONITORING_PROVIDER: process.env.NEXT_PUBLIC_MONITORING_PROVIDER,
//         NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
//         NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
//         NEXT_PUBLIC_BASELIME_KEY: process.env.NEXT_PUBLIC_BASELIME_KEY,
//         NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
//         NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
//         NEXT_PUBLIC_SUPABASE_PUBLIC_KEY: process.env.NEXT_PUBLIC_SUPABASE_PUBLIC_KEY,
//         NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
//         NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
//         NEXT_PUBLIC_PRODUCT_NAME: process.env.NEXT_PUBLIC_PRODUCT_NAME,
//         NEXT_PUBLIC_SITE_TITLE: process.env.NEXT_PUBLIC_SITE_TITLE,
//         NEXT_PUBLIC_SITE_DESCRIPTION: process.env.NEXT_PUBLIC_SITE_DESCRIPTION,
//         NEXT_PUBLIC_DEFAULT_THEME_MODE: process.env.NEXT_PUBLIC_DEFAULT_THEME_MODE,
//         NEXT_PUBLIC_THEME_COLOR: process.env.NEXT_PUBLIC_THEME_COLOR,
//         NEXT_PUBLIC_THEME_COLOR_DARK: process.env.NEXT_PUBLIC_THEME_COLOR_DARK,
//         NEXT_PUBLIC_AUTH_PASSWORD: process.env.NEXT_PUBLIC_AUTH_PASSWORD,
//         NEXT_PUBLIC_CAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY,
//         NEXT_PUBLIC_BILLING_PROVIDER: process.env.NEXT_PUBLIC_BILLING_PROVIDER,
//         NEXT_PUBLIC_KEYSTATIC_CONTENT_PATH: process.env.NEXT_PUBLIC_KEYSTATIC_CONTENT_PATH,
//         NEXT_PUBLIC_KEYSTATIC_STORAGE_KIND: process.env.NEXT_PUBLIC_KEYSTATIC_STORAGE_KIND,
//         NEXT_PUBLIC_KEYSTATIC_STORAGE_REPO: process.env.NEXT_PUBLIC_KEYSTATIC_STORAGE_REPO,
//         NEXT_PUBLIC_LOCALES_PATH: process.env.NEXT_PUBLIC_LOCALES_PATH,
//         NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
//         NEXT_PUBLIC_ENABLE_THEME_TOGGLE: process.env.NEXT_PUBLIC_ENABLE_THEME_TOGGLE,
//         NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_DELETION: process.env.NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_DELETION,
//         NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_BILLING: process.env.NEXT_PUBLIC_ENABLE_PERSONAL_ACCOUNT_BILLING,
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_DELETION: process.env.NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_DELETION,
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_BILLING: process.env.NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_BILLING,
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS: process.env.NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS,
//         NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_CREATION: process.env.NEXT_PUBLIC_ENABLE_TEAM_ACCOUNTS_CREATION,
//         NEXT_PUBLIC_LANGUAGE_PRIORITY: process.env.NEXT_PUBLIC_LANGUAGE_PRIORITY,

//         // Navigation
//         NEXT_PUBLIC_USER_NAVIGATION_STYLE: process.env.NEXT_PUBLIC_USER_NAVIGATION_STYLE,
//         NEXT_PUBLIC_HOME_SIDEBAR_COLLAPSED: process.env.NEXT_PUBLIC_HOME_SIDEBAR_COLLAPSED,
//         NEXT_PUBLIC_TEAM_NAVIGATION_STYLE: process.env.NEXT_PUBLIC_TEAM_NAVIGATION_STYLE,
//         NEXT_PUBLIC_TEAM_SIDEBAR_COLLAPSED: process.env.NEXT_PUBLIC_TEAM_SIDEBAR_COLLAPSED,
//         NEXT_PUBLIC_SIDEBAR_COLLAPSIBLE_STYLE: process.env.NEXT_PUBLIC_SIDEBAR_COLLAPSIBLE_STYLE,
//         NEXT_PUBLIC_ENABLE_SIDEBAR_TRIGGER: process.env.NEXT_PUBLIC_ENABLE_SIDEBAR_TRIGGER,

//         // Notifications
//         NEXT_PUBLIC_ENABLE_NOTIFICATIONS: process.env.NEXT_PUBLIC_ENABLE_NOTIFICATIONS,
//         NEXT_PUBLIC_REALTIME_NOTIFICATIONS: process.env.NEXT_PUBLIC_REALTIME_NOTIFICATIONS,

//         // Features
//         NEXT_PUBLIC_ENABLE_VERSION_UPDATER: process.env.NEXT_PUBLIC_ENABLE_VERSION_UPDATER,
//         NEXT_PUBLIC_VERSION_UPDATER_REFETCH_INTERVAL_SECONDS: process.env.NEXT_PUBLIC_VERSION_UPDATER_REFETCH_INTERVAL_SECONDS,
//         NEXT_PUBLIC_DISPLAY_TERMS_AND_CONDITIONS_CHECKBOX: process.env.NEXT_PUBLIC_DISPLAY_TERMS_AND_CONDITIONS_CHECKBOX,
//         NEXT_PUBLIC_AUTH_IDENTITY_LINKING: process.env.NEXT_PUBLIC_AUTH_IDENTITY_LINKING,
//         NEXT_PUBLIC_AUTH_OTP: process.env.NEXT_PUBLIC_AUTH_OTP,
//         TURBO_TELEMETRY_DISABLED: process.env.TURBO_TELEMETRY_DISABLED,
//         DO_NOT_TRACK: process.env.DO_NOT_TRACK,
//     }
// })

// // if (env.NEXT_PUBLIC_PRIVATEMODE_API_KEY) {
// //     console.warn("Warning: NEXT_PUBLIC_PRIVATEMODE_API_KEY is leaking to the client side. This should be disabled in production.");
// // }
// // if (env.LLM_ROUTER === 'openrouter') {
// //     console.warn("Warning: OpenRouter is not GDPR compliant, please use Requesty instead.");
// // }

// export default env

// const env = {}
// Object.keys(process.env).forEach(key => {
//     // @ts-ignore
//     env[key] = process.env[key]
// })

// for (const key in env) {
//     // @ts-ignore
//     if (env[key] === "true") {
//         // @ts-ignore
//         env[key] = true
//         // @ts-ignore
//     } else if (env[key] === "false") {
//         // @ts-ignore
//         env[key] = false
//     }
// }
// export default env

// copy process.env to a new object
// const env = process.env
// Object.keys(process.env).forEach(key => {
//     // @ts-ignore
//     env[key] = process.env[key]
//     if (process.env[key] === "true") {
//         // @ts-ignore
//         env[key] = true
//     } else if (process.env[key] === "false") {
//         // @ts-ignore
//         env[key] = false
//     }
// })
// export default env

export function envBool(
  value: string | boolean | undefined,
  defaultValue: boolean,
): boolean;
export function envBool(
  value: string | boolean | undefined,
): boolean | undefined;
export function envBool(
  value: string | boolean | undefined,
  defaultValue?: boolean,
): boolean | undefined {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }
  return defaultValue;
}
